<template>
  <div class="ma-6">
    <div class="page-header-left">
      <h2 class="pr-3">Histories</h2>
    </div>
    <div class="mt-4 pr-0 pl-0 pt-2" style="border: thin solid rgba(0,0,0,.12)">
      <v-tabs  v-model="tab">
        <v-tab>Histori Pembayaran</v-tab>
        <v-tab>Mutasi Saldo</v-tab>
        <v-tab-item>
          <PaymentHistories/>
        </v-tab-item>
        <v-tab-item>
          <MutasiSaldo/>
        </v-tab-item>
      </v-tabs>
    </div>
  </div>
</template>

<script>
import MutasiSaldo from '@/components/MutasiSaldo'
import PaymentHistories from '@/components/PaymentHistories'
export default {
  name: 'Histories',
  components: { PaymentHistories, MutasiSaldo },
  data: () => ({
    tab: null
  })
}
</script>

<style scoped>

</style>
